import React from 'react'
import * as DataUtils from '../util/DataUtils'

export default function ContentContainer(props) {
  if (typeof(props)==='object'&&props!==null) {
    const content = props
    if (typeof(content)==='object'&&content!==null) {
      const type = content[DataUtils.TYPE]
      if (typeof(type)==='string'&&type.length>0) {
        try {
          const Content = require(`../contents/${type}`).default
          return (
            <Content {...content} />
          )
        } catch (e) {
          console.warn('ContentContainer',props,e)
        }
      }
    }
  }
  return (
    <div>
      Something went wrong.
      Probably failed to find content with props of
      <code><pre>
        {JSON.stringify(props,null,2)}
      </pre></code>
      Really Sorry :(
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/ContentContainer.js